export default __webpack_public_path__ + "static/media/modal-background.png";